import JobIconLayout from './JobIconLayout'
export default JobIconLayout
